import React from 'react';
import {useLocation, useHistory} from 'react-router-dom';
import {parse, stringify} from 'query-string';

import {usePrevious} from 'front-onceforall-core/dist/utils/customHooks';

import {useCustomStore} from '../GlobalSubcontractorsStore';

import ListView from './ListView';

function ListContainer() {
  const {dispatch} = useCustomStore();
  const location = useLocation();
  const prevLocation = usePrevious(location.pathname + location.search);
  const history = useHistory();
  const [pageNumber, setPageNumber] = React.useState(typeof parse(location.search).page === 'undefined' ? 0 : Number(parse(location.search).page));

  React.useEffect(() => {
    if (prevLocation && prevLocation !== (location.pathname + location.search)) {
      dispatch({type: 'FETCH_DATA'});
    }
  });

  const updateSearchLocation = custom => {
    let search = parse(location.search);
    search = {...search, ...custom};
    search = stringify(search);
    history.push(`${location.pathname}?${search}`);
  };

  const handlePageChange = (event, page) => {
    setPageNumber(page);
    updateSearchLocation({page});
  };

  const handleSearch = query => {
    setPageNumber(0);
    updateSearchLocation({query, page: 0});
  };

  return (
    <ListView
      onPageChange={handlePageChange}
      onSearch={handleSearch}
      pageNumber={pageNumber}
    />
  );
}

export default ListContainer;
